import { z } from 'zod';

const StatsSchema = z.object({
  old_count: z.number(),
  new_count: z.number(),
  common_count: z.number(),
  old_only_count: z.number(),
  new_only_count: z.number(),
  old_rows_count: z.number().optional(),
  new_rows_count: z.number().optional(),
});

const DifferencesSchema = z.record(z.string(), z.array(z.unknown()));

const ColumnDifferencesSchema = z.object({
  new_only: z.array(z.string()),
  old_only: z.array(z.string()),
});

const EmployeeDataSchema = z.object({
  stats: StatsSchema,
  differences: DifferencesSchema,
});

const ApplicantDataSchema = z.object({
  stats: StatsSchema,
  differences: DifferencesSchema,
});

export const TransformCompareOutputSchema = z.object({
  column_differences: ColumnDifferencesSchema,
  employee_data: EmployeeDataSchema,
  applicant_data: ApplicantDataSchema,
});

export type TransformCompareOutput = z.infer<
  typeof TransformCompareOutputSchema
>;
